export default __webpack_public_path__ + "static/footer-4ed69d858e65cd09de37398b7aebe4a2.svg";